import React, { useContext, useState } from "react";
import { OidcConfigurationNameContext } from "./contexts/OidcConfigurationNameContext";
import { OidcSecure } from "@axa-fr/react-oidc";
import Chat from "./Chat";

import { ChatOptionsProvider } from "./components/providers/ChatOptionsProvider";
import { SendingProvider } from "./components/providers/SendingProvider";
import { useOidcConfigList } from "./hooks/useOidcConfigList";
import LoginPage from "./LoginPage";
import { PromptTemplatesProvider } from "./components/providers/PromptTemplatesProvider";
import AuthenticatedLoadingWrapper from "./components/AuthenticatedLoadingWrapper";
import { PromotionsLoadingWrapper } from "./components/PromotionsLoadingWrapper";
import { AvailablePromotionsCarouselProvider } from "./components/providers/AvailablePromotionsCarouselProvider";
import { RagSourcesProvider } from "./components/providers/RagSourcesProvider";
import { UserInfoProvider } from "./components/providers/UserInfoProvider";
import { ImpersonationProvider } from "./components/providers/ImpersonationProvider";

interface OidcSecureChatProps {
  betaBannerVisible?: boolean;
}

export const OidcSecureChat = ({ betaBannerVisible = true }: OidcSecureChatProps) => {
  const { oidcConfigurationName } = useContext(OidcConfigurationNameContext);
  const { oidcConfigList } = useOidcConfigList();

  let configuration = oidcConfigList.find(
    (c) => c.name === oidcConfigurationName,
  );

  if (configuration == null || oidcConfigurationName === "default") {
    return <LoginPage />;
  }

  return (
    <OidcSecure configurationName={oidcConfigurationName}>
      <UserInfoProvider>
        <ImpersonationProvider>
 <RagSourcesProvider>
          <ChatOptionsProvider>
            <PromptTemplatesProvider>
              <AvailablePromotionsCarouselProvider>
                <SendingProvider>
                  <AuthenticatedLoadingWrapper>
                    <PromotionsLoadingWrapper>
                      <Chat betaBannerVisible={betaBannerVisible} />
                    </PromotionsLoadingWrapper>
                  </AuthenticatedLoadingWrapper>
                </SendingProvider>
              </AvailablePromotionsCarouselProvider>
            </PromptTemplatesProvider>
          </ChatOptionsProvider>
        </RagSourcesProvider>
        </ImpersonationProvider>
      </UserInfoProvider>
    </OidcSecure>
  );
};
